import { Box, Stack, Typography, useTheme } from '@mui/material';
import { important } from '../../utils/global/helper';
import type { HeaderContent } from '../../types/reports';
import { getTableBorderColor } from '../../utils/table';
import TableAction from './TableAction';

interface Props {
  name: string;
  showing: number;
  total: number;
  small?: boolean;
  action?: HeaderContent['action'];
}

export default function TableTitle({
  name,
  showing,
  total,
  small,
  action,
}: Props) {
  const theme = useTheme();
  return (
    <Stack
      p={4}
      direction="row"
      justifyContent={action ? 'space-between' : 'flex-start'}
      alignItems="center"
      borderBottom={`1px solid ${getTableBorderColor(theme, 'regular')}`}>
      <Box
        className="table-title-row"
        sx={{
          paddingY: small ? important(theme.spacing(2.5)) : undefined,
        }}>
        <Typography variant={small ? 'h5' : 'h2'}>{name}</Typography>
        <Typography variant={small ? 'body2' : 'body1'}>
          Showing {showing} of {total}
        </Typography>
      </Box>
      {action && <TableAction {...action} />}
    </Stack>
  );
}
